import type { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    border: 'none',
  },
  'variant-horizontal': {
    flexDirection: 'row',
    '& > *': {
      marginLeft: theme.spacing(1),
    },
    '& > *:first-child': {
      marginLeft: 0,
    },
  },
  'variant-vertical': {
    flexDirection: 'column',
  },
}));
